<template>
    <div class="group">
        <van-search
            v-model="keywords"
            shape="round"
            placeholder="请输入搜索关键词"
            @search="onSearch"
            right-icon="search"
            >
        </van-search>
        <van-tabs @click="onClick" color="#025DF4">
            <van-tab name="1" title="单项联盟"></van-tab>
            <van-tab name="2" title="区域联盟"></van-tab>
        </van-tabs>
        <List v-model="loading" :finished="finished" finished-text="没有更多了" @load="getlist">
            <div class="item" v-for="item in list" :key="item.id">
                <div class="top">
                    <img class="img" src="https://oss.mcloud.moveclub.cn/alphamovecloud/20230822/1692671454/429874.png" alt="">
                    <div class="title">
                        <div>{{item.name}}</div>
                        <div>
                            <div><img src="https://oss.mcloud.moveclub.cn/alphamovecloud/20230824/1692846042/222236.png" alt=""></div>
                            <div v-if="item.type==2">{{item.areatype | statusFiler}} | {{item.project}}</div>
                            <div v-else>{{item.project}}</div>
                        </div>
                    </div>
                </div>
                <div class="bottom">
                    <div>
                        <div>
                            <img src="https://oss.mcloud.moveclub.cn/alphamovecloud/20230823/1692776405/123250.png" alt="">
                            <span>团队数量</span>
                        </div>
                        <div>
                            <span>{{item.groupnum}}</span>
                        </div>
                    </div>
                    <div class="btn" @click="go(item)">查看详情</div>
                </div>
            </div>
        </List>
    </div>
</template>

<script>
import { Search,List } from 'vant';
import localforage from 'localforage'
export default {
    components: {
        vanSearch: Search,List
    },
    data() {
        return {
            keywords: '',
            type: '1',
            page: 1,
            finished: false,
            loading: false,
            list: []
        }
    },
    filters: {
        statusFiler(val) {
            switch(val*1) {
                case 1:
                    return '街道社区'
                case 2:
                    return '商务楼宇'
                case 3:
                    return '企业单位'
                case 4:
                    return '校园'
            }
        }
    },
    mounted() {

    },
    methods: {
        go(item) {
            this.$router.push({name:'groupdetail',params: {aid:item.id}})
        },
        onSearch(val) {
            this.keywords = val
            this.finished = false
            this.list = []
        },
        onClick(name, title) {
            this.type = name
            this.finished = false
            this.list = []
        },
        async getlist() {
            const userInfo = await localforage.getItem('userInfo')
            // console.log(userInfo)
            let query = {
                type: this.type*1,
                keywords: this.keywords,
                page: this.page,
                openid: userInfo.openid
            }
            this.$api.system.grouplist(query).then((res) => {
                if (res.code * 1 === 200) {
                    this.loading = false
                    let { list, page, pages } = res.data
                    this.list = this.list.concat(list)
                    if (page >= pages) this.finished = true
                    else this.page++
                }
            })
        },
    }
}
</script>

<style lang="less" scoped>
.group{
    background: #F4F5F7;
    overflow-y: auto;
    width: 100%;
    height: auto;
    .van-list{
        display: flex;
        flex-direction: column;
        align-items: center;
        box-sizing: border-box;
        padding: .3rem 0;
        .item{
            width: 6.93rem;
            height: 2.48rem;
            margin-bottom: .28rem;
            background: #FFFFFF;
            box-shadow: 0px 0px .18rem 0px rgba(0,0,0,0.06);
            border-radius: .12rem;
            .top{
                width: 100%;
                height: 1.63rem;
                background: url(https://oss.mcloud.moveclub.cn/alphamovecloud/20230823/1692776405/486337.png) no-repeat;
                background-size: 100% 100%;
                display: flex;
                box-sizing: border-box;
                padding: .37rem .45rem .32rem;
                align-items: center;
                .img{
                    width: .94rem;
                    height: .94rem;
                    border-radius: 50%;
                }
                .title{
                    width: 4.8rem;
                    margin-left: .3rem;
                    >div:first-child{
                        font-size: .32rem;
                        color: rgba(0,0,0,0.85);
                        font-weight: 500;
                        padding-bottom: .1rem;
                    }
                    >div:nth-child(2){
                        font-size: .24rem;
                        color: #95999F;
                        display: flex;
                        align-items: center;
                        >div:first-child{
                            width: .3rem;
                            height: .3rem;
                            img{
                                width: .3rem;
                                height: .3rem;
                            }
                        }
                        
                    }
                }
            }
            .bottom{
                display: flex;
                align-items: center;
                box-sizing: border-box;
                padding: 0 .45rem;
                justify-content: space-between;
                width: 100%;
                height: .85rem;
                >div:first-child{
                    display: flex;
                    width: 50%;
                    font-size: .24rem;
                    align-items: center;
                    // justify-content: space-between;
                    color: rgba(0,0,0,0.45);
                    img{
                        width: .26rem;
                        height: .26rem;
                        margin-right: .1rem;
                    }
                    >div:first-child{
                        display: flex;
                        align-items: center;
                    }
                    >div:nth-child(2){
                        padding-left: .4rem;
                        color: #025DF4;
                    }
                }
                .btn{
                    width: 1.4rem;
                    height: .5rem;
                    line-height: .5rem;
                    text-align: center;
                    background: #025DF4;
                    border-radius: .25rem;
                    font-size: .24rem;
                    color: #FFFFFF;
                }
            }
        }
    }
}
</style>